export default "__VITE_ASSET__CAvVdNuD__"